<template>
    <v-card class="uploadDocument">
        <!-- <v-toolbar class="elevation-0">
            <v-toolbar-title>Importation Stripe</v-toolbar-title>
        </v-toolbar> -->
        <v-container fluid>
            <v-text-field-filled
                class="d-flex justify-start"
                outlined
                label="Fichier"
                v-model="fileName"
                @click="$refs.inputUpload.click()"
                prepend-icon="$attach_file"
                style="width: 50%; margin-right: auto; margin-left: auto"
                density="compact"
            />
            <input
                v-show="false"
                ref="inputUpload"
                type="file"
                accept=".csv"
                @change="onFileChanged"
            />
            <v-row no-gutters class="py-2">
                <v-col cols="12">
                    <oss-text-field
                        v-model="vatRate"
                        v-if="fileName"
                        dense
                        outlined
                        :suffix="'%'"
                        label="Taux de TVA"
                        style="width: 50%; margin-right: auto; margin-left: auto"
                        @update:model-value="computeVatRate()"
                    />
                </v-col>
                <v-col cols="12">
                    <v-window v-model="wizardStep" touchless v-if="fileName">
                        <v-window-item :value="0">
                            <v-row no-gutters class="py-2 justify-center">
                                <v-data-table
                                    :headers="headers"
                                    :items="data"
                                    class="table"
                                    fixed-header
                                    max-height="60vh"
                                >
                                    <template v-slot:item="props">
                                        <tr
                                            :class="props.item.selected ? 'info ' : ''"
                                            :style="
                                                isInDB(props.item.importId)
                                                    ? 'background: #FFCDD2'
                                                    : ''
                                            "
                                        >
                                            <td
                                                class="text-center"
                                                :style="
                                                    isInDB(props.item.importId)
                                                        ? 'background: #FFCDD2 !important'
                                                        : ''
                                                "
                                            >
                                                {{ props.item.name }}
                                            </td>
                                            <td
                                                class="text-center"
                                                :style="
                                                    isInDB(props.item.importId)
                                                        ? 'background: #FFCDD2 !important'
                                                        : ''
                                                "
                                            >
                                                {{ formatDate(props.item.date) }}
                                            </td>
                                            <td
                                                class="text-center"
                                                :style="
                                                    isInDB(props.item.importId)
                                                        ? 'background: #FFCDD2 !important'
                                                        : ''
                                                "
                                            >
                                                {{ props.item.thirdParty.name }}
                                            </td>
                                            <!-- <td class="text-center">
                                                <v-switch
                                                    v-model="props.item.thirdParty.pro"
                                                    inset
                                                    dense
                                                    color="secondary"
                                                ></v-switch>
                                            </td> -->
                                            <td
                                                class="text-center"
                                                :style="
                                                    isInDB(props.item.importId)
                                                        ? 'background: #FFCDD2'
                                                        : ''
                                                "
                                            >
                                                {{
                                                    newCommonFormatCurrency(
                                                        props.item.netAmount,
                                                        undefined,
                                                    )
                                                }}
                                            </td>
                                            <td
                                                class="text-center"
                                                :style="
                                                    isInDB(props.item.importId)
                                                        ? 'background: #FFCDD2'
                                                        : ''
                                                "
                                            >
                                                {{
                                                    newCommonFormatCurrency(
                                                        props.item.vatAmount,
                                                        undefined,
                                                    )
                                                }}
                                            </td>
                                            <td
                                                class="text-center"
                                                :style="
                                                    isInDB(props.item.importId)
                                                        ? 'background: #FFCDD2'
                                                        : ''
                                                "
                                            >
                                                {{
                                                    newCommonFormatCurrency(
                                                        props.item.grossAmount,
                                                        undefined,
                                                    )
                                                }}
                                            </td>
                                            <td
                                                class="text-center"
                                                :style="
                                                    isInDB(props.item.importId)
                                                        ? 'background: #FFCDD2'
                                                        : ''
                                                "
                                            >
                                                {{
                                                    isInDB(props.item.importId)
                                                        ? "Déjà enregistrée"
                                                        : ""
                                                }}
                                            </td>
                                        </tr>
                                    </template>
                                </v-data-table>
                                <v-col cols="12" class="d-flex justify-end">
                                    <v-btn rounded elevation="0" @click="wizardStep++" size="small">
                                        Suivant
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </v-window-item>
                        <v-window-item :value="1">
                            <v-row no-gutters class="py-2">
                                <template v-if="companies.length">
                                    <v-col
                                        cols="5"
                                        class="px-2 flex-shrink-0 flex-grow-1"
                                        style="max-height: 50vh; overflow-y: auto"
                                    >
                                        <v-switch
                                            v-model="allIsConsumer"
                                            v-if="fileName"
                                            label="Tous les clients sont des particuliers"
                                        />
                                        <v-list width="100%" v-if="companies.length">
                                            <v-list-item
                                                v-for="(company, index) in companies"
                                                :key="index"
                                                class="my-1"
                                                @click="companiesSelected = index"
                                                :style="
                                                    index === companiesSelected
                                                        ? 'background: rgba(109, 192, 189, 0.3) !important'
                                                        : ''
                                                "
                                            >
                                                <v-row no-gutters>
                                                    <v-col>
                                                        {{ company.name }}
                                                    </v-col>
                                                    <v-col class="d-flex justify-center">
                                                        {{
                                                            company &&
                                                            company.link &&
                                                            company.link.name
                                                                ? company.link.name
                                                                : ""
                                                        }}
                                                    </v-col>
                                                    <v-col class="d-flex justify-center">
                                                        <v-switch
                                                            v-model="company.consumer"
                                                            hide-details
                                                            label="Particulier"
                                                        />
                                                    </v-col>
                                                    <v-col cols="1" class="d-flex justify-end">
                                                        <v-icon
                                                            color="secondary"
                                                            v-if="company.link && company.link.name"
                                                        >
                                                            $fa-check-circle
                                                        </v-icon>
                                                    </v-col>
                                                </v-row>
                                            </v-list-item>
                                        </v-list>
                                    </v-col>
                                    <v-col
                                        class="d-flex align-center justify-center px-2 flex-shrink-1 flex-grow-0"
                                        height="100%"
                                    >
                                        <v-icon>$fa-arrow-left</v-icon>
                                    </v-col>
                                    <v-col cols="6" class="px-2 flex-shrink-0 flex-grow-1">
                                        <CompaniesTable
                                            :showGenericCompany="false"
                                            :showConsumerCompanies="true"
                                            :showCustomerCompanies="true"
                                            :showSupplierCompanies="false"
                                            :showExistingCompanies="false"
                                            :parentCompanyId="company.id"
                                            :company="''"
                                            :wizardMode="true"
                                            @select-company="
                                                companies[companiesSelected].link = $event
                                            "
                                        />
                                    </v-col>
                                </template>
                                <v-col cols="6" class="d-flex pt-3">
                                    <v-btn @click="wizardStep--" rounded elevation="0" size="small"
                                        >Précédent</v-btn
                                    >
                                </v-col>
                                <v-col cols="6" class="d-flex justify-end pt-3">
                                    <v-btn
                                        @click="upload()"
                                        rounded
                                        elevation="0"
                                        :loading="uploadLoading"
                                        size="small"
                                        >Upload</v-btn
                                    >
                                </v-col>
                            </v-row>
                        </v-window-item>
                    </v-window>
                </v-col>
            </v-row>
        </v-container>
    </v-card>
</template>

<script lang="ts">
import csvtojson from "csvtojson";
import gql from "graphql-tag";
import _ from "lodash";
import moment from "moment-timezone";
import { Apollo } from "@/decorators";

import CompaniesTable from "./admin/CompaniesTable.vue";
import { newCommonFormatCurrency } from "../../../backend/src/common/services/mathServices";

import IMPORT_STRIPE from "../graphql/document/ImportStripe.gql";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";
import { Watch } from "vue-facing-decorator";

@Component({
    components: {
        CompaniesTable,
    },
    emits: ["importDone"],
})
export class ImportStripe extends Vue {
    @Prop({ default: null }) companyId;

    data: any = [];

    allIsConsumer = false;

    wizardStep = 0;

    fileName = "";

    companiesSelected = 0;

    companies = [];

    vatRate = 20;

    uploadLoading = false;

    newCommonFormatCurrency(value, options = undefined) {
        return newCommonFormatCurrency(value, undefined);
    }

    headers = [
        // Header du tableau
        { title: "Nom", value: "name", align: "center", sortable: false },
        { title: "Date", value: "date", align: "center", sortable: false },
        { title: "Client", value: "", align: "center", sortable: false },
        // { title: "IsPro", value: "", align: "center", sortable: false },
        { title: "Montant HT", value: "netAmount", align: "center", sortable: false },
        { title: "Montant TVA", value: "vatAmount", align: "center", sortable: false },
        { title: "Montant TTC", value: "grossAmount", align: "center", sortable: false },
        { title: "", sortable: false },
    ];

    get company() {
        return this.$store.state.selected_company;
    }

    get labelStatus() {
        if (this.fileName.substring(0, 7) === "Stripe-") {
            return "Status";
        }
        return "Type";
    }

    close = function emitToTheParentToCloseTheDialog() {
        this.$emit("close");
    };

    setData = function settingDataInConvertFECObject(data) {
        data.shift();
        debugger;
        this.data = data.map((x) => ({
            importId: "STRIPE_" + x.id,
            date: moment(x["Created (UTC)"], "dd/MM/yyyy hh:mm").toISOString(),
            thirdParty: {
                name: x["customer_name (metadata)"],
            },
            grossAmount: this.formatAmount(x["Converted Amount"]),
            name: x["Activit�"],
            status: x[this.labelStatus],
            fee: this.formatAmount(x.Fee),
        }));
        this.data = this.data.filter((x) => x.status === "Paid");
        this.computeVatRate();
        this.companies = _.uniqBy(
            this.data.map((x) => ({ name: x.thirdParty.name, consumer: false, link: {} })),
            "name",
        );
    };

    formatAmount(amount) {
        const formatingAmount = amount.replace(",", ".");
        return parseFloat(formatingAmount);
    }

    // getVatAmount(netAmount) {
    //     return parseFloat((netAmount * this.vatRate / 100).toFixed(2))
    // }

    formatDate(date) {
        return moment(date).format("DD/MM/yyyy");
    }

    async onFileChanged(e) {
        if (e && e.target && e.target.files) {
            const file = e.target.files[0];
            const self = this;

            const reader = new FileReader();
            reader.onload = async function () {
                if (reader.result) {
                    self.fileName = file.name.toString();
                    const data = await csvtojson({
                        noheader: false,
                        trim: true,
                        // eslint-disable-next-line no-tabs
                        delimiter: ";",
                    }).fromString(reader.result.toString());
                    self.setData(data);
                }
            };
            console.log(await reader.readAsText(file));
        }
    }

    async upload() {
        this.uploadLoading = true;
        await this.$apollo.mutate({
            mutation: IMPORT_STRIPE,
            variables: {
                lines: this.data,
                companyId: this.company.id,
                clientCompanies: this.companies,
            },
        });
        this.$emit("importDone");
        this.uploadLoading = false;
    }

    @Apollo({
        query: gql`
            query documentsByImportID($importId: [String!], $companyId: ID!) {
                documents(where: { importId_in: $importId, company: { id: $companyId } }) {
                    importId
                    id
                }
            }
        `,
        variables() {
            return {
                importId: this.data.map((x) => x.importId),
                companyId: this.company.id,
            };
        },
        skip() {
            return this.data.length === 0;
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data && data.documents) {
                    debugger;
                    this.importedDocuments = data.documents;
                }
            }
        },
    })
    importedDocuments = [];

    @Watch("allIsConsumer")
    setConsumerClient() {
        for (const company of this.companies) {
            company.consumer = this.allIsConsumer;
            if (this.allIsConsumer) company.link = null;
        }
    }

    isInDB(id) {
        const doc = this.importedDocuments.find((x) => x.importId === id);
        return !!doc;
    }

    computeVatRate() {
        for (const x of this.data) {
            x.vatRate = this.vatRate;
            x.netAmount = x.grossAmount / (1.0 + this.vatRate / 100.0);
            x.vatAmount = x.grossAmount - x.netAmount;
        }
    }
}

export default toNative(ImportStripe);
</script>

<style lang="scss" scoped>
.row-bc-selected {
    background-color: #ffcdd2 !important;
}
</style>
